var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10H12.8333M11.2778 6.11111C11.2778 7.82933 9.88489 9.22222 8.16667 9.22222C6.44845 9.22222 5.05556 7.82933 5.05556 6.11111C5.05556 4.39289 6.44845 3 8.16667 3C9.88489 3 11.2778 4.39289 11.2778 6.11111ZM3.5 16.2222C3.5 13.6449 5.58934 11.5556 8.16667 11.5556C10.744 11.5556 12.8333 13.6449 12.8333 16.2222V17H3.5V16.2222Z",
    stroke: "#0076A8",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemove);
export default __webpack_public_path__ + "static/media/icon-remove.343941374dc52c648ba96f50ef664ce5.svg";
export { ForwardRef as ReactComponent };